export const BOARD_FILTER_API_PATH = '/rest/greenhopper/1.0/rapidviewconfig/filter';

export const SAVED_FILTER_API_PATH = '/rest/greenhopper/1.0/savedfilter/list.json';

export const UPDATE_ISSUE_RANK_API_PATH = '/rest/greenhopper/1.0/rapidviewconfig/orderbyrank';

export const FILTER_API_PATH = '/rest/api/3/filter';
